import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankWebServiceIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 28,
	viewBox: "0 0 32 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M29 12H24V27H31V14C31 12.8954 30.1046 12 29 12Z",
			stroke: "#85A0AD",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 12H3C1.89543 12 1 12.8954 1 14V27H8V12Z",
			stroke: "#85A0AD",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3818 1H9.36365C8.25908 1 7.36365 1.89543 7.36365 3V27H24.3818V3C24.3818 1.89543 23.4864 1 22.3818 1Z",
			fill: "white",
			stroke: "#85A0AD",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7798 19.5602V17.6335",
			stroke: "#FF3131",
			strokeWidth: 1.2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7798 8V9.92669",
			stroke: "#FF3131",
			strokeWidth: 1.2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9907 12.4952V11.853C18.9907 10.7853 18.1317 9.92627 17.064 9.92627H14.4951C13.4273 9.92627 12.5684 10.7853 12.5684 11.853C12.5684 12.9207 13.4273 13.7797 14.4951 13.7797H17.064C18.1317 13.7797 18.9907 14.6386 18.9907 15.7063C18.9907 16.7741 18.1317 17.633 17.064 17.633H14.4951C13.4273 17.633 12.5684 16.7741 12.5684 15.7063V15.0641",
			stroke: "#FF3131",
			strokeWidth: 1.2,
			strokeMiterlimit: 10
		})
	]
});
export default SvgBankWebServiceIcon;
